<template>
	<div
		class="rb-comment"
		:class="{spoiler: comment.IsSpoiler && !showSpoilers, deleted: comment.Deleted, child: comment.ParentId}"
		@click.right.prevent="showAdmin = !showAdmin"
	>
		<div class="avatar">
			<img :src="comment.User.AvatarUrl" alt="">
		</div>

		<div class="body pl-4">
			<rb-button
				class="float-right" variant="danger"
				v-b-tooltip.hover
				title="Remover comentário"
				@click="removeComment(comment)"
				v-if="loggedUser && (comment.User.Id === loggedUser.Id || (loggedUser.IsAdmin && showAdmin))"
			>
				<rb-icon>trash</rb-icon>
			</rb-button>
			<rb-button
				class="float-right mr-2" variant="info"
				v-b-tooltip.hover
				title="Marcar como spoiler"
				@click="markCommentAsSpoiler(comment)"
				v-if="loggedUser && loggedUser.IsAdmin && showAdmin"
			>
				<rb-icon>eye-slash</rb-icon>
			</rb-button>

			<h4>
				<b>{{comment.User.Name}}</b>
				<small class="text-grey d-inline-block ml-3">
					{{comment.Timestamp.format('d/m/Y H:i')}}
				</small>
			</h4>

			<rb-markdown class="body-text" :value="comment.Text"></rb-markdown>

			<div
				class="comment-actions"
				v-if="loggedUser"
			>
				<span class="action-link" v-if="!comment.ParentId" @click="replying = !replying">
					<rb-icon>reply</rb-icon> Responder
				</span>
			</div>

			<rb-collapse :collapsed="!replying">
				<rb-comment-composer
					:video="video"
					:parent="comment"
					class="mt-4"
					@sent="replying = false"
				></rb-comment-composer>
			</rb-collapse>

			<rb-comment
				v-for="childComment in childComments" :key="childComment.Id"
				:comment="childComment"
				:video="video"
				:showSpoilers="showSpoilers"
			></rb-comment>
		</div>
	</div>
</template>

<script>
	import {Video, VideoComment} from '../../../../shared/entities/Video';
	import RbMarkdown from '../RbMarkdown';
	import {mapState} from 'vuex';
	import RbCollapse from '../RbCollapse';
	import RbCommentComposer from './RbCommentComposer';
	import RbButton from '../RbButton';

	export default {
		name: 'RbComment',
		components: { RbButton, RbCommentComposer, RbCollapse, RbMarkdown},
		data: () => ({
			reply: '',
			replying: false,
			showAdmin: false
		}),
		props: {
			showSpoilers: {
				type: Boolean,
				required: true
			},
			video: {
				type: Video,
				required: true
			},
			/** @type {VideoComment} **/
			comment: {
				type: VideoComment,
				require: true
			}
		},
		methods: {
			/**
			 * @param {VideoComment} comment
			 * @returns {Promise<void>}
			 */
			async removeComment(comment) {
				const data = await this.$oldApi.Video.removeComment(comment.Id);
				this.comment.Deleted = data.Deleted;
			},

			/**
			 * @param {VideoComment} comment
			 * @returns {Promise<void>}
			 */
			async markCommentAsSpoiler(comment) {
				const data = await this.$oldApi.Video.markCommentAsSpoiler(comment.Id);
				this.comment.IsSpoiler = data.IsSpoiler;
			}
		},
		computed: {
			...mapState([
				'loggedUser'
			]),
			childComments() {
				const isAdmin = (this.loggedUser && this.loggedUser.IsAdmin);
				return isAdmin ? this.comment.Comments : this.comment.Comments.filter(c => !c.Deleted);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-comment {
		display: flex;
		margin: 1.5em 0;

		> .avatar {
			flex-shrink: 0;
			width: 50px;
			height: 50px;
			border-radius: 50%;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		> .body {
			flex-grow: 1;
		}

		&.deleted {
			opacity: .3;
		}

		&.child:last-child {
			margin-bottom: 0;
		}

		&.spoiler {
			.body-text {
				filter: blur(10px);
				cursor: pointer;
			}
		}

		&.spoiler:hover {
			.body-text {
				filter: blur(0px);
			}
		}

		.comment-actions {
			font-size: $font-size-xs;
			user-select: none;

			.action-link {
				cursor: pointer;
				transition: all .3s;
				opacity: .6;

				&:hover {
					opacity: .8;
				}
			}
		}
	}
</style>
